import { createContext, useEffect, useState } from "react";

import { buildApiUrl } from "../services/api";

const BiensContext = createContext({
  biens: [],
  saleBiens: [],
  rentBiens: [],
  setBiens: () => {},
  loading: false,
  saleLoading: false,
  rentLoading: false,
});

const normalizeBien = (item) => ({
  ...item,
  id: item?.node?.id,
  position: {
    lat: Number.parseFloat(item?.node?.attributes?.location?.geo?.latitude),
    lng: Number.parseFloat(item?.node?.attributes?.location?.geo?.longitude),
  },
  info: `Bien ID: ${item?.node?.id}`,
});

export const BiensProvider = ({ children }) => {
  const [biens, setBiens] = useState([]);
  const [rentBiens, setRentBiens] = useState([]);
  const [saleLoading, setSaleLoading] = useState(true);
  const [rentLoading, setRentLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const fetchSaleBiens = async () => {
      try {
        const saleResponse = await fetch(buildApiUrl("/server/api/houseforsale/biens"));

        if (!saleResponse.ok) {
          throw new Error("Failed to fetch property data");
        }

        const saleData = await saleResponse.json();

        if (!Array.isArray(saleData)) {
          throw new Error("API returned an unexpected payload for biens.");
        }

        if (!isCancelled) {
          setBiens(saleData.map(normalizeBien));
        }
      } catch (error) {
        console.error("Erreur lors du chargement des biens a vendre:", error);

        if (!isCancelled) {
          setBiens([]);
        }
      } finally {
        if (!isCancelled) {
          setSaleLoading(false);
        }
      }
    };

    const fetchRentBiens = async () => {
      try {
        const rentResponse = await fetch(buildApiUrl("/server/api/housetorent/biens"));

        if (!rentResponse.ok) {
          throw new Error("Failed to fetch rent property data");
        }

        const rentData = await rentResponse.json();

        if (!Array.isArray(rentData)) {
          throw new Error("API returned an unexpected payload for rent biens.");
        }

        if (!isCancelled) {
          setRentBiens(rentData.map(normalizeBien));
        }
      } catch (error) {
        console.error("Erreur lors du chargement des biens a louer:", error);

        if (!isCancelled) {
          setRentBiens([]);
        }
      } finally {
        if (!isCancelled) {
          setRentLoading(false);
        }
      }
    };

    fetchSaleBiens();
    fetchRentBiens();

    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <BiensContext.Provider
      value={{
        biens,
        saleBiens: biens,
        rentBiens,
        setBiens,
        loading: saleLoading && rentLoading,
        saleLoading,
        rentLoading,
      }}
    >
      {children}
    </BiensContext.Provider>
  );
};

export default BiensContext;
